import { getCurrentInstance } from "vue";
import request from "@/utils/newServer";
export default function exportApi(key, val) {
	const { proxy } = getCurrentInstance();
	const queryParams = new proxy.$EsayParam();
	queryParams.put(key, val)
	queryParams.put("appCode", 'CG')
	const esayInfo = new proxy.$EsayInfo();
	esayInfo.add(queryParams)
	return request({
		url: '/iiot/doEvent/mdCommonTypeApi/getCommonItems',
		method: 'post',
		data: {
			num:0,
			"id": "99u8239",
			...esayInfo
		}
	})
}
